// material
import { Card, Skeleton } from '@mui/material';

// ----------------------------------------------------------------------

export default function TotalTodaySkeleton() {
  return (
    <Card>
      <Skeleton width='20%' sx={{ mt: 3, mx: 3 }} />
      <Skeleton variant='rectangular' height='560px' sx={{ m: 3 }} />
    </Card>
  );
}
